<template>
  <div class="basic_list_photos basic-icon-combination">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="list_frame" v-loading="loading">

      <circle-layout v-if="isCircleLayout()"
                     :pc_infor="pc_infor"
                     :infor="infor"
                     :imgs="imgs"
                     :module="module"></circle-layout>

      <template v-else>
        <div :class="['list_box','list-box-'+listArr.module_style]" ref="rowEL">
          <template v-for="(item,i) in imgs">
            <one_icon
              :item="item"
              :i="i"
              :key="i"
              :pc_infor="pc_infor"
              :infor="infor"
              :imgs="imgs"
              :module="module"
            ></one_icon>
          </template>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import one_icon from "./components/one_icon";
import {debounce} from "throttle-debounce";
import CircleLayout from './components/circle_layout'
import Store from "../../vuex/store";
import {box_shadow_style_add, getCommonStyle} from "@/base/widgets_data_compatible";

export default {
  name: "basic_icon_combination",
  components: {
    one_icon,
    CircleLayout
  },
  data() {
    return {
      imgs: [],
      loading: false,
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    infor() {
      return this.module.data[
      this.$store.state.app.view_pattern + "_widgets_infor"
        ];
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr
    },
  },
  watch: {
    "module.data.listArr": {
      handler: function (val, oldVal) {
        this.templet.icons_init(this)
      },
      deep: true
    },
    "listArr.module_style"(val){
      if(val !== 3){
        this.module.data.pc_infor.marginLeft = '0%'
        this.module.data.pc_infor.marginRight = '0%'
      }
    }
  },
  methods: {
    isCircleLayout() {
      return Number(this.listArr.module_style) === 3
    },
    fixField(){
      this.fixBoxShadowData()
      // 圆角
      if (typeof this.pc_infor.borderRadius == "undefined") {
        this.$set(this.pc_infor, "borderRadius", getCommonStyle().borderRadius);
      }
    },
    fixBoxShadowData() {
      if (typeof this.pc_infor.boxShadow == "undefined") { // 这个地方需要特殊处理  之前是有组合阴影的 shadowVisible true 和 false
        let box_shadow = {
          ...box_shadow_style_add().boxShadow,
        }
        if (typeof this.pc_infor.shadowVisible != 'undefined') box_shadow.radio_val = 'custom'
        if (this.pc_infor.shadowVisible == 'false') {
          box_shadow.custom.color = 'rgba(254,254,254,0)';
          box_shadow.custom.seColor = 'rgba(254,254,254,0)';
        }
        if (this.pc_infor.shadowVisible == 'true') {
          box_shadow.custom.color = 'rgba(0,0,0,0.20)';
          box_shadow.custom.seColor = 'rgba(0,0,0,0.20)';
          box_shadow.custom.blur = 6
          box_shadow.custom.y = 1
        }
        this.$set(this.pc_infor, "boxShadow", box_shadow);
      }
    }
  },
  created() {
    this.templet.icons_init(this)
    this.fixField()
    if (typeof this.pc_infor.titleFont.default.selectColor === 'undefined') {
      this.$set(this.pc_infor.titleFont.default, 'selectColor', 'rgba(50,50,50,1)')
    }
    if (typeof this.pc_infor.titleFont.custom.selectColor === 'undefined') {
      this.$set(this.pc_infor.titleFont.custom, 'selectColor', 'rgba(50,50,50,1)')
    }

    if (typeof this.pc_infor.summaryFont.default.selectColor === 'undefined') {
      this.$set(this.pc_infor.summaryFont.default, 'selectColor', 'rgba(153,153,153,1)')
    }
    if (typeof this.pc_infor.summaryFont.custom.selectColor === 'undefined') {
      this.$set(this.pc_infor.summaryFont.custom, 'selectColor', 'rgba(153,153,153,1)')
    }

    if (typeof this.pc_infor.set_style.background.default.seColor === 'undefined') {
      this.$set(this.pc_infor.set_style.background.default, 'seColor', 'rgba(255, 255, 255,1)')
    }
    if (typeof this.pc_infor.set_style.background.custom.seColor === 'undefined') {
      this.$set(this.pc_infor.set_style.background.custom, 'seColor', 'rgba(255, 255, 255,1)')
    }
    
  },
  mounted() {
    

  },
  beforeDestroy() {

  }
};
</script>

<style scoped lang="scss">
.basic-icon-combination {
  .list_frame {
    width: 100%;

    .list_box {
      display: flex;
      flex-flow: wrap;
      font-size: 0;
      position: relative;
    }

  }
}

.pc_pattern {
  .list_frame {
    min-height: 50px;
  }
}

.mb_pattern {
  .list_one {
    padding: 1.89% !important;
  }

  .list_box {
    padding: 1.89% !important;
  }

  .list_frame {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_icon_combination/index.vue